class WaterMark {

    constructor(_window, _document) {

        this.window = _window;
        this.document = _document;   
    }
    
    addWaterMark() {
        var waterMarkContainer = this.document.createElement('div');
        var waterText = this.window.scorm.get('cmi.core.student_id');
        var index_base = 2;

        $(this.document.body).append(waterMarkContainer);
        $(waterMarkContainer).css(
            {
                "width": "103vw",
                "height": "100vh",
                "position": "fixed",
                "top": "0",
                "left": "0",
                "opacity": "0.05",
                "pointer-events" : "none",
                "z-index": index_base,
                
            }
        );

        for (var i = 0; i < 4200; i++) {
            $(waterMarkContainer).append(waterText + " ");
        }

        var arrObjectsToDeph = $(this.document).find('p,h1,h2,h3,h4,h5,i,b,stronger, a, .container-slides, .container-item-card, video, audio, .component-template-header, .container-accordeon, .container-timeline, .exercise-memory, .remove_waterMark');
        arrObjectsToDeph = arrObjectsToDeph.get().reverse();


        $(arrObjectsToDeph).each(function(){

            if($(this).css("position") != "absolute" && $(this).css("position") != "fixed"){
                $(this).css(
                    {
                        "position": "relative",
                        "z-index": index_base++
                    }
                );
            }
            else{
                $(this).css(
                    {
                        "z-index": index_base++
                    }
                );
            }
            
        });        

    };

    getMaxZIndex() {
        const maxZIndex = Array.from(document.querySelectorAll("body *"))
            .map((el) => parseFloat(window.getComputedStyle(el).zIndex))
            .filter((zIndex) => !isNaN(zIndex))
            .reduce((max, current) => Math.max(max, current), 0);
        return maxZIndex;
    }
      

}
